<template>
  <div class="stage-path">
    <div v-if="isActive">
      <div class="active-stage-line">
        <div class="line-1" />
        <AppIcon name="rocket_icon" />
        <div class="line-2" />
      </div>
    </div>
    <div v-else-if="isFinished" class="solid-line" />
    <div v-else class="dashed-line" />
    <div
      v-if="!isFinished"
      :class="[
        'bottom-text',
        isActive ? 'active' : ''
      ]"
    >
      <span class="text-1">
        {{ bottomTextLineOne }}
      </span>
      <span class="text-2">
       {{ bottomTextLineTwo }}
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  isActive: {
    type: Boolean,
    default: false
  },
  beforeStage: {
    type: [Number, String],
    default: 1
  }
})

const { leftDays, leftHours, leftMinutes, leftSeconds } = useTimeLeft();
const settings = useState(appStateConstants.SETTINGS);

const bottomTextLineOne = computed(() => {
  if (props.isActive) {
    return getContent('section_stablecoin_explanation.stage_path_time_left');
  } else if (isStartDateVisible.value) {
    return getContent('section_stablecoin_explanation.stage_path_start');
  } else {
    return getContent('section_stablecoin_explanation.stage_path_to_be');
  }
});

const bottomTextLineTwo = computed(() => {
  if (props.isActive) {
    return `${leftDays.value}:${leftHours.value}:${leftMinutes.value}:${leftSeconds.value}`;
  } else if (this.isStartDateVisible) {
    return startDate.value;
  } else {
    return getContent('section_stablecoin_explanation.stage_path_announced');
  }
});

const startDate = computed(() => {
  if (!settings.value?.token_sale_start_date) {
    return '';
  };
  
  const date = new Date(settings.value.token_sale_start_date.replace(' ', 'T'));
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
});

const isStartDateVisible = computed(() => {
  return props.beforeStage - Number(settings.value?.token_sale_stage) === 2;
});
const isFinished = computed(() => {
  return Number(settings.value?.token_sale_stage) >= Number(props.beforeStage);
});
</script>

<style lang="scss" scoped>
.stage-path {
  width: 180px;
  position: relative;
  flex-shrink: 0;

  .active-stage-line {
    display: flex;
    gap: 4px;
    align-items: center;

    .line-1 {
      width: 70px;
      border-top: 1px $yellow-100 solid;
    }

    .line-2 {
      width: 70px;
      border-top: 1px $yellow-100 dashed;
    }
  }

  .dashed-line {
    border-top: 1px $yellow-100 dashed;
  }

  .solid-line {
    border-top: 1px $yellow-100 solid;
  }

  .bottom-text {
    position: absolute;
    text-align: center;
    color: $yellow-100;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;

    &.active {
      top: 55px;
    }

    .text-1 {
      font-size: 12px;
      line-height: 18px;
      text-transform: uppercase;
      white-space: nowrap;
      display: block;
    }

    .text-2 {
      font-size: 16px;
      line-height: 18px;
      text-transform: uppercase;
      display: block;
    }
  }
}
</style>
